import { ObjectMapper } from "json-object-mapper";
import { IModel } from "services/models/IModel";
import { Model } from "services/models/model";

export class TrainingTypeModel
  extends Model
  implements IModel<TrainingTypeModel> {
  name: string = "";
  companyGroupId: string | undefined = undefined;
  description: string = "";
  validateHeadcountPlanning: boolean = false;
  isAptitude: boolean = false;

  static create(input: any): TrainingTypeModel {
    return ObjectMapper.deserialize<TrainingTypeModel>(
      TrainingTypeModel,
      input
    );
  }
}